import {useTranslation} from "react-i18next";
import LanguageContentSection from "../../common/LanguageContentSection";
import logo from "../../../../assets/login/login_logo.png";
import React, {useEffect, useState} from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import {loginService} from "../../../../services/authService/loginService";
import {loginSuccess, setAccessToken, setUserData} from "../../../../redux/authSlice";
import {toast} from "react-toastify";
import {profileSettingService} from "../../../../services/profileSettingService/profileSettingService";
import {useLogout} from "../../../../hooks/useLogout";

const AdminLoginCallbackSection = () => {
    //  states start
    const { t } = useTranslation();
    const [isProcessing, setIsProcessing] = useState(true);

    const { search } = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { performLogout } = useLogout();

    useEffect(() => {
        const processAdminLogin = async () => {
            try {
                if (localStorage.getItem("access_token")) {
                    await performLogout();
                }

                const params = new URLSearchParams(search);
                const rid = params.get('rid');
                const token = params.get('token');

                if (!rid || !token) {
                    console.error('Invalid admin login link - missing rid or token');
                    toast.error('Invalid admin login link');
                    navigate('/');
                    return;
                }

                const payload = { rid, token };

                const response = await loginService.exchangeAdminMagic(payload);
                
                if (response?.data?.data?.token) {
                    localStorage.setItem("access_token", response.data?.data?.token);
                    localStorage.setItem("masterClass", response.data?.data?.masterclass);
                    localStorage.setItem("is_admin_impersonation", "true");
                    
                    dispatch(setAccessToken(response.data?.data?.token));
                    const user = response?.data?.data?.user;
                    toast.success(`Successfully logged in as ${response.data?.data?.student_name}`);
                    dispatch(loginSuccess(user));
                    localStorage.setItem("user", JSON.stringify(user));

                    const profileResponse = await profileSettingService.getUserProfileData(user?.id);
                    const fetchedUserData = profileResponse?.data?.data;
                    dispatch(setUserData(fetchedUserData));
                    navigate("/dashboard");
                } else {
                    console.error('Login failed:', response?.data?.message);
                    toast.error(response?.data?.message);
                    navigate('/');
                }
            } catch (ex) {
                toast.error(ex?.response?.data?.message || 'Failed to login as student');
                navigate('/');
            } finally {
                setIsProcessing(false);
            }
        };

        processAdminLogin();
    }, [search, navigate, dispatch]);

    // states end
    return (
        <>
            {/* login content section start */}
            <div className="login-content-section">
                {/* language selection start */}
                <div className="login-language-section">
                    <LanguageContentSection />
                </div>
                {/* language selection end */}

                {/* login content form start */}
                <div className="login-content-form">
                    <div className="login-catapult-logo">
                        <img crossOrigin="anonymous" src={logo} alt="Website Logo" className="logo-image" />
                    </div>
                    <div className="login-form">
                        <div>
                            {isProcessing ? 'Signing you in as student…' : 'Processing complete'}
                        </div>
                    </div>
                </div>
                {/* login content form end */}

                <div className="login-footer">
                    <Link to="/">{t("COMMON.LOGIN.NOW")}</Link>
                </div>
            </div>
            {/* login content section end */}
        </>
    );
};

export default AdminLoginCallbackSection;
